module.exports = __webpack_public_path__ + "static/media/Background.77d5eb6a.svg";